export default class FocusTrap {
    constructor(
        parentElement,
        firstFocusableElement = null,
        lastFocusableElement = null
    ) {
        this.parentElement = parentElement;
        this.trapActive = false;
        this.firstFocusableElement = firstFocusableElement;
        this.lastFocusableElement = lastFocusableElement;
    }

    activate() {
        if (!this.trapActive) {
            this.trapActive = true;
            const allFocusableElements = Array.from(
                this.parentElement.querySelectorAll(
                    'a, button, input:not([type="hidden"]):not([aria-hidden="true"]), select, textarea, [tabindex]:not([tabindex="-1"])'
                )
            );
            if (this.firstFocusableElement === null) {
                [this.firstFocusableElement] = allFocusableElements;
            }
            if (this.lastFocusableElement === null) {
                this.lastFocusableElement =
                    allFocusableElements[allFocusableElements.length - 1];
            }
            this.parentElement.addEventListener('keydown', this.handleKeyDown.bind(this));
        }
    }

    refresh() {
        this.deactivate();
        this.firstFocusableElement = null;
        this.lastFocusableElement = null;
        this.activate();
    }

    deactivate() {
        if (this.trapActive) {
            this.trapActive = false;
            this.parentElement.removeEventListener(
                'keydown',
                this.handleKeyDown
            );
        }
    }

    handleKeyDown(event) {
        if (event.key === 'Tab') {
            if (event.shiftKey) {
                if (document.activeElement === this.firstFocusableElement) {
                    event.preventDefault();
                    this.lastFocusableElement.focus();
                }
            } else if (document.activeElement === this.lastFocusableElement) {
                event.preventDefault();
                this.firstFocusableElement.focus();
            }
        }
    }
}
